import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/ord-orders/download-shipping-label/{order_uuid}/{store_uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type DownloadShippingLabelInput = paths[url]['post']['parameters']['path'];

/**
 * Requests endpoint to download the shipping label for an order.
 */
export const useDownloadShippingLabel = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();

    const [loading, setLoading] = useState<boolean>(false);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [error, setError] = useState<boolean | null>(null);

    const request = async (props: DownloadShippingLabelInput) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{order_uuid}', props.order_uuid || '').replace('{store_uuid}', props.store_uuid || '')}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(getCommonParameters()),
            });

            setError(!response.ok);

            if (!response.ok) {
                const error = new Error() as ApiError;
                error.message = '';
                error.statusCode = response.status;
                throw error;
            }

            const blob = await response.blob();

            // trigger the download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            // cspell:disable-next-line
            link.download = 'guia.pdf'; // filename
            link.click();

            // clean up
            URL.revokeObjectURL(link.href);

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime };
};
